import { render, staticRenderFns } from "./ProductsHead.vue?vue&type=template&id=7637cb4a&scoped=true"
import script from "./ProductsHead.vue?vue&type=script&lang=js"
export * from "./ProductsHead.vue?vue&type=script&lang=js"
import style0 from "./ProductsHead.vue?vue&type=style&index=0&id=7637cb4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637cb4a",
  null
  
)

export default component.exports